import _ from "lodash";
import selectors from "../selectors";
import { getAccessToken } from "../lib/auth";

function defaultHeaders(state: any) {
  return _.pickBy(
    {
      "Content-Type": "application/json",
      "Authorization": getAccessToken(),
      "X-GOGOVAPPS-SITE": selectors.site(state).site,
    },
    _.identity,
  );
}

function defaultHeadersWithSite(site: string) {
  return _.pickBy(
    {
      "Content-Type": "application/json",
      "Authorization": getAccessToken(),
      "X-GOGOVAPPS-SITE": site,
    },
    _.identity,
  );
}

function defaultHeadersWithoutJson(state: any) {
  return _.pickBy(
    {
      "Authorization": getAccessToken(),
      "X-GOGOVAPPS-SITE": selectors.site(state).site,
    },
    _.identity,
  );
}

export const networkSelectors = {
  defaultHeaders,
  defaultHeadersWithSite,
  defaultHeadersWithoutJson,
};
export default networkSelectors;
